export default {
  dbi_pc_console_metric_type_sales: 'Sales',
  dbi_pc_console_metric_type_pcu_acu: 'PCU/ACU',
  dbi_pc_console_metric_type_mau: 'MAU',
  dbi_pc_console_metric_type_dau: 'DAU',
  dbi_pc_console_metric_type_engagement: 'Engagement',
  dbi_pc_console_metric_type_wishlist_follows: 'Wishlist and Follows',
  dbi_pc_console_metric_type_price_reviews: 'Price & Steam Reviews',
  dbi_pc_console_metric_type_retention: 'Retention',
  dbi_pc_console_metric_type_no_update: 'No Update',
  // 这块用dbi_metric为前缀， 后面使用value值
  dbi_metric_digitalRevenue: 'Digital Revenue($)',
  dbi_metric_usdigitalRevenue: 'US Digital REV($)',
  dbi_metric_digitalRevenueNoDo: 'Digital Revenue',
  dbi_metric_digital_units: 'Digital Units',
  dbi_metric_units: 'Units',
  dbi_metric_digitalARPPU: 'Digital ARPPU($) (US only)',
  // dbi_metric_ast: 'AST($)',
  dbi_metric_ast: 'AST',
  dbi_metric_steam_est_revenue: 'Steam Premium Revenue($)',
  dbi_metric_est_revenue: 'Premium Revenue($)',
  dbi_metric_previous_mau: 'Previous MAU',
  dbi_metric_added_mau: 'Added Users',
  dbi_metric_new_mau: 'New Users',
  dbi_metric_new_dau: 'New Users',
  dbi_metric_retained_mau: 'Retained Users',
  dbi_metric_churned_mau: 'Churned Users',
  dbi_metric_cumulative_revenue: 'Cumulative Premium Revenue($)',
  dbi_metric_est_units: 'Steam Units',
  dbi_metric_est_price: 'Steam Price($)',
  dbi_metric_player_share: 'Player Share',
  dbi_metric_mau_growth: 'MAU Growth',
  dbi_metric_mau_new: 'MAU - New',
  dbi_metric_mau_returning: 'MAU - Returning',
  dbi_metric_lifetime_player: 'Lifetime Players',
  dbi_metric_avg_daily_playtime: 'Avg Daily Playtime (mins)',
  dbi_metric_avg_daily_sessions: 'Avg Daily Sessions',
  dbi_metric_avg_days_played: 'Avg Days Played',
  dbi_metric_avg_monthly_playtime: 'Avg Monthly Playtime (hours)',
  dbi_metric_acquisition_rate: 'Acquisition Rate',
  dbi_metric_avg_monthly_sessions: 'Avg Monthly Sessions',
  dbi_metric_avg_playtime_per_session: 'Avg Playtime Per Session (mins)',
  dbi_metric_stickiness: 'Stickiness',
  dbi_metric_total_hours: 'Total Hours',
  dbi_metric_time_spent_0H: 'Time Spent 0-1 hrs',
  dbi_metric_time_spent_1H: 'Time Spent 1-5 hrs',
  dbi_metric_time_spent_5H: 'Time Spent 5-10 hrs',
  dbi_metric_time_spent_10H: 'Time Spent 10-25 hrs',
  dbi_metric_time_spent_25H: 'Time Spent 25-50 hrs',
  dbi_metric_time_spent_50H: 'Time Spent > 50 hrs',
  dbi_metric_avg_daily_playtime_min: 'Avg Daily Playtime (mins)',
  dbi_metric_avg_daily_sessions2: 'Avg Daily Sessions',
  dbi_metric_avg_days_played2: 'Avg Days Played',
  dbi_metric_avg_playtime_per_session_min: 'Avg Playtime Per Session (mins)',
  dbi_metric_avg_monthly_sessions2: 'Avg Monthly Sessions',
  dbi_metric_avg_monthly_playtime_hour: 'Avg Monthly Playtime (hours)',
  dbi_metric_avg_dailly_playtime_hour: 'Avg Daily Playtime (hours)',
  dbi_metric_daily_wishlist: 'Daily Wishlist',
  dbi_metric_lifetime_wishlist: 'Lifetime Wishlist',
  dbi_metric_steam_daily_wishlist: 'Steam Daily Wishlist',
  dbi_metric_steam_lifetime_wishlist: 'Steam Lifetime Wishlist',
  // Gamalytic指标专用国际化key
  dbi_metric_gamalytic_steam_est_revenue: 'Steam Revenue($)',
  dbi_metric_gamalytic_est_revenue: 'Steam Revenue($)',
  dbi_metric_gamalytic_steam_cumulative_premium_revenue: 'Steam Cumulative Revenue($)',
  dbi_metric_gamalytic_jptb_cumulative_revenue_trends: 'Steam Cumulative Revenue($)',
  dbi_metric_gamalytic_est_units: 'Steam Units',
  dbi_metric_gamalytic_steam_cumulative_units: 'Steam Cumulative Units',
  dbi_metric_gamalytic_steam_pcu: 'Steam PCU',
  dbi_metric_gamalytic_steam_acu: 'Steam ACU',
  dbi_metric_gamalytic_steam_followers: 'Steam Followers',
  dbi_metric_gamalytic_steam_reviews: 'Steam Reviews',
  dbi_metric_gamalytic_steam_total_reviews: 'Steam Total Reviews',
  dbi_metric_gamalytic_est_price: 'Steam Price($)',
  dbi_metric_gamalytic_weighted_price: 'Steam Weighted Price($)',
  dbi_metric_gamalytic_lifetime_weighted_price_trends: 'Steam Lifetime Weighted Price($)',
  dbi_metric_gamalytic_players_by_country: 'Steam Players by Country',
  dbi_metric_gamalytic_steam_daily_wishlist: 'Steam Daily Wishlist',
  dbi_metric_gamalytic_steam_lifetime_wishlist: 'Steam Lifetime Wishlist',
  dbi_metric_gamalytic_playtime_steam: 'Steam Avg. Playtime(hours)',
  dbi_metric_gamalytic_followers: 'Steam Total Followers',
  // Alinea指标专用国际化key
  dbi_metric_alinea_steam_est_revenue: 'Steam Revenue($)',
  dbi_metric_alinea_est_revenue: 'Steam Revenue($)',
  dbi_metric_alinea_steam_cumulative_premium_revenue: 'Steam Cumulative Revenue($)',
  dbi_metric_alinea_steam_cumulative_revenue: 'Steam Cumulative Revenue($)',
  dbi_metric_alinea_jptb_cumulative_revenue_trends: 'Steam Cumulative Revenue($)',
  dbi_metric_alinea_est_units: 'Steam Units',
  dbi_metric_alinea_steam_cumulative_units: 'Steam Cumulative Units',
  dbi_metric_alinea_steam_pcu: 'Steam PCU',
  dbi_metric_alinea_steam_acu: 'Steam ACU',
  dbi_metric_alinea_steam_followers: 'Steam Followers',
  dbi_metric_alinea_steam_reviews: 'Steam Reviews',
  dbi_metric_alinea_steam_total_reviews: 'Steam Total Reviews',
  dbi_metric_alinea_steam_players: 'Steam Players',
  dbi_metric_alinea_steam_total_players: 'Steam Total Players',
  dbi_metric_alinea_steam_positive_reviews: 'Steam Positive Reviews',
  dbi_metric_alinea_steam_total_positive_reviews: 'Steam Total Positive Reviews',
  dbi_metric_alinea_est_price: 'Steam Price($)',
  dbi_metric_alinea_weighted_price: 'Steam Weighted Price($)',
  dbi_metric_alinea_lifetime_weighted_price_trends: 'Steam Lifetime Weighted Price($)',
  dbi_metric_alinea_players_by_country: 'Steam Players by Country',
  dbi_metric_alinea_wishlists_by_country: 'Steam Wishlists by Countries',
  dbi_metric_alinea_steam_daily_wishlist: 'Steam Daily Wishlist',
  dbi_metric_alinea_steam_lifetime_wishlist: 'Steam Lifetime Wishlist',
  dbi_metric_alinea_dau: 'DAU',
  dbi_metric_alinea_mau: 'MAU',
  dbi_metric_alinea_playtime_steam: 'Steam Avg. Playtime(mins)',
  dbi_metric_alinea_followers: 'Steam Total Followers',
  // Alinea PlayStation metrics
  dbi_metric_alinea_ps_revenue: 'PS Revenue',
  dbi_metric_alinea_ps_revenue_total: 'PS Revenue Total',
  dbi_metric_alinea_ps_units: 'PS Units',
  dbi_metric_alinea_ps_units_total: 'PS Units Total',
  dbi_metric_alinea_ps_lifetime_players: 'PS Players',
  dbi_metric_alinea_ps_plus_total_players: 'PS Total Players',
  dbi_metric_alinea_ps_game_pass_players: 'PS game pass players',
  dbi_metric_alinea_ps_game_pass_players_total: 'PS game pass total players',
  dbi_metric_alinea_ps_dau: 'PS DAU',
  dbi_metric_alinea_ps_mau: 'PS MAU',
  dbi_metric_alinea_ps_players_by_country: 'PS Players by Country',
  dbi_metric_alinea_ps_price: 'PS Price',
  // Alinea Xbox metrics
  dbi_metric_alinea_xbox_revenue: 'Xbox Revenue',
  dbi_metric_alinea_xbox_revenue_total: 'Xbox Revenue Total',
  dbi_metric_alinea_xbox_units: 'Xbox Units',
  dbi_metric_alinea_xbox_units_total: 'Xbox Units Total',
  dbi_metric_alinea_xbox_players: 'Xbox Players',
  dbi_metric_alinea_xbox_game_pass_total_players: 'Xbox Total Players',
  dbi_metric_alinea_xbox_game_pass_players: 'Xbox game pass players',
  dbi_metric_alinea_xbox_game_pass_players_total: 'Xbox game pass total players',
  dbi_metric_alinea_xbox_dau: 'Xbox DAU',
  dbi_metric_alinea_xbox_mau: 'Xbox MAU',
  dbi_metric_alinea_xbox_price: 'Xbox Price',
  dbi_metric_rolling_d1: 'Rolling D1',
  dbi_metric_rolling_d7: 'Rolling D7',
  dbi_metric_rolling_d14: 'Rolling D14',
  dbi_metric_rolling_d28: 'Rolling D28',
  dbi_metric_rolling_d60: 'Rolling D60',
  dbi_metric_monthly_rolling_d1: 'Monthly Rolling D1',
  dbi_metric_monthly_rolling_d7: 'Monthly Rolling D7',
  dbi_metric_monthly_rolling_d14: 'Monthly Rolling D14',
  dbi_metric_monthly_rolling_d28: 'Monthly Rolling D28',
  dbi_metric_monthly_rolling_d60: 'Monthly Rolling D60',

  // dbi_metric_avg_mau: 'Avg MAU', //TODO
  dbi_metric_jpseg_sales: 'Sales of selected time',
  dbi_metric_jpseg_revenue: 'Revenue of selected time',
  dbi_metric_jpseg_cumulative_sales: 'Cumulative Sales',
  dbi_metric_jpseg_cumulative_revenue: 'Cumulative Revenue',
  dbi_metric_jpseg_price: 'Price',
  dbi_metric_jptb_sales: 'Sales of selected time',
  dbi_metric_jptb_revenue: 'Revenue of selected time($)',
  dbi_metric_jptb_sales_latest_week: 'Sales of the latest week',
  dbi_metric_jptb_revenue_latest_week: 'Revenue of the latest week',
  dbi_metric_jptb_cumulative_sales: 'Cumulative Sales of the latest week',
  dbi_metric_jptb_cumulative_revenue: 'Cumulative Revenue of the latest week($)',
  dbi_label_metric_est_revenue: 'Est.Revenue',
  dbi_label_metric_est_units: 'Est.Units',
  dbi_metric_jptb_price: 'Price($)',
  dbi_metric_famitsu_price: 'Famitsu Price($)',
  dbi_metric_physical_revenue: 'Physical Revenue($)',
  dbi_metric_usphysical_revenue: 'US Physical Revenue($)',
  dbi_metric_physical_revenue1: 'Physical Revenue',
  dbi_metric_pcu: 'PCU',
  dbi_metric_acu: 'ACU',
  dbi_metric_avgplayers: 'Avg. Players',
  dbi_metric_rank: 'Rank',
  dbi_metric_dau: 'DAU',
  dbi_metric_wau: 'WAU',
  dbi_metric_mau: 'MAU',
  dbi_metric_revenue: 'Revenue',
  dbi_metric_downloads: 'Downloads',
  dbi_metric_acquisition: 'Acquisition %',
  dbi_metric_churn: 'Churn %',
  dbi_metric_engagement: 'Engagement',
  dbi_metric_engagement_active: 'Engagement',
  dbi_metric_engagement_active_level: 'Engagement',
  dbi_metric_churn_acquisition: 'Churn/Acquisition',
  dbi_metric_atime_spent_0H: 'Time Spent',
  dbi_metric_retention: 'Retention',
  dbi_metric_retention_d2: 'Retention D2',
  dbi_metric_retention_d3: 'Retention D3',
  dbi_metric_retention_d7: 'Retention D7',
  dbi_metric_retention_d15: 'Retention D15',
  dbi_metric_retention_d31: 'Retention D31',
  dbi_KPIOverview_d1: 'D1',
  dbi_metric_ampere_d1: 'D1',
  dbi_metric_ampere_d7: 'D7',
  dbi_metric_ampere_d14: 'D14',
  dbi_metric_ampere_d28: 'D28',
  dbi_metric_ampere_d60: 'D60',
  dbi_metric_monthly_ampere_d1: 'Monthly D1',
  dbi_metric_monthly_ampere_d7: 'Monthly D7',
  dbi_metric_monthly_ampere_d14: 'Monthly D14',
  dbi_metric_monthly_ampere_d28: 'Monthly D28',
  dbi_metric_monthly_ampere_d60: 'Monthly D60',
  dbi__metric_store_rank_top_seller: 'Steam Top Wishlist',
  dbi__metric_store_rank_top_seller_overview: 'Top Seller',
  dbi__metric_store_rank_top_wishlist: 'Top Wishlist',
  dbi__metric_all_reviews: 'All Reviews',
  dbi_metric_price_dol: 'Price($)',
  dbi_metric_lifetime_revenue: 'Lifetime Total Revenue($)',
  dbi_metric_d1_after_release_revenue: 'Day 1 after Release Total Revenue($)',
  dbi_metric_w1_after_release_revenue: 'Week 1 after Release Total Revenue($)',
  dbi_metric_m1_after_release_revenue: 'Month 1 after Release Total Revenue($)',
  dbi_metric__y1_after_release_revenue: 'Y1 after release Total Revenue($)',
  dbi_metric_y1_fter_ea_revenue: 'Y1 after EA Total Revenue($)',
  dbi_metric_last_month_Revenue: 'Last Month Digital Revenue($)',

  dbi_metric_lifetime_full_units: 'Lifetime Base Game Sales Units',
  dbi_metric_d1_after_release_full_units: 'Day 1 after Release Base Game Sales Units',
  dbi_metric_w1_after_release_full_units: 'Week 1 after Release Base Game Sales Units',
  dbi_metric_m1_after_release_full_units: 'Month 1 after Release Base Game Sales Units',
  dbi_metric_y1_after_release_full_units: 'Y1 after release Base Game Sales Units',
  dbi_metric_y1_after_ea_full_units: 'Y1 after EA Base Game Sales Units',
  dbi_metric_last_month_full_units: 'Last Month Digital Base Game Units',

  dbi_metric_y1_after_ea_definition: 'The first full calendar year following a games release into Early Access',
  dbi_metric_m1_after_release_definition: 'Including all pre-order revenue during the pre-order period',
  dbi_metric_est_cumulative_units: 'Cumulative Units',
  dbi_metric_weighted_price: 'Weighted Price($)',
  dbi_metric_lifetime_weighted_price: 'Lifetime weighted price($)',
  dbi_metric_players_by_country: 'Players by country',
  dbi_metric_playtime: 'Avg. Playtime(mins)',
  dbi_metric_followers: 'Total Followers',

  dbi_metric_rpd_asfor: `RPD($) as for {time}`,
  dbi_metric_cumulative_downloads: `Cumulative Downloads`,
  dbi_metric_cumulative_revenue_$: 'Cumulative Revenue($)',
  dbi_metric_hourswatched: `Hours Watched(hours)`,
  dbi_metric_hourswatched_simple: 'Hours Watched',
  dbi_metric_peakccv: `Peak CCV`,
  dbi_metric_avgccv: `Avg CCV`,
  dbi_metric_airtime: `Airtime(hours)`,
  dbi_metric_airtime_simple: `Airtime`,
  dbi_metric_digital_arpu_$: 'Digital ARPPU($)',
  dbi_metric_usdigital_arpu_$: 'US Digital ARPPU($)',
  dbi_metric_digital_arpu_dollor_tips: 'Digital ARPPU($) is only available when US is selected.',
  dbi_metric_ast_$: 'AST($)',
  dbi_metric_rpd_$: 'RPD($)',
  dbi_metric_revenue_per_download_$: 'Revenue($) Per Download',

  dbi_metric_steam_pcu: 'Steam PCU',
  dbi_metric_steam_acu: 'Steam ACU',
  dbi_metric_steam_price$: 'Steam Price($)',
  dbi_metric_steam_revenue: 'Steam Revenue($)',
  dbi_metric_steam_cumulative_revenue: 'Steam Cumulative Revenue($)',
  dbi_metric_steam_units: 'Steam Units',
  dbi_metric_steam_cumulative_units: 'Steam Cumulative Units',
  dbi_metric_steam_weighted_price$: 'Steam Weighted Price($)',
  dbi_metric_steamdata: 'Steam Data',
  dbi_metric_steam_followers: 'Steam Followers',
  dbi_metric_steam_reviews: 'Steam Reviews',
  dbi_metric_vgi_steam_pcu: 'Steam PCU',
  dbi_metric_vgi_steam_acu: 'Steam ACU',
  dbi_metric_vgi_steam_followers: 'Steam Followers',
  dbi_metric_vgi_steam_reviews: 'Steam Reviews',
  dbi_metric_vgi_steam_est_revenue: 'Steam Premium Revenue($)',
  dbi_metric_vgi_steam_cumulative_revenue: 'Steam Cumulative Revenue($)',
  dbi_metric_vgi_steam_units: 'Steam Units',
  dbi_metric_vgi_steam_cumulative_units: 'Steam Cumulative Units',
  dbi_metric_vgi_steam_daily_wishlist: 'Steam Daily Wishlist',
  dbi_metric_vgi_steam_lifetime_wishlist: 'Steam Lifetime Wishlist',
  dbi_metric_vgi_steam_price: 'Steam Price($)',
  dbi_metric_vgi_lifetime_weighted_price: 'Steam Lifetime Weighted Price($)',
  dbi_metric_vgi_steam_playtime: 'Steam Avg. Playtime(mins)',
  dbi_metric_vgi_est_revenue: 'Steam Premium Revenue($)',
  dbi_metric_vgi_cumulative_revenue: 'Steam Cumulative Revenue($)',
  dbi_metric_vgi_units: 'Steam Units',
  dbi_metric_vgi_cumulative_units: 'Steam Cumulative Units',
  dbi_metric_vgi_daily_wishlist: 'Steam Daily Wishlist',
  dbi_metric_vgi_lifetime_wishlist: 'Steam Lifetime Wishlist',
  dbi_metric_vgi_price: 'Steam Price($)',
  dbi_metric_vgi_weighted_price: 'Steam Weighted Price($)',
  dbi_metric_vgi_playtime: 'Steam Avg. Playtime(mins)',
  dbi_metric_vgi_followers: 'Steam Total Followers',
  dbi_metric_vgi_players_by_country: 'Steam Players by Country',

  dbi_metric_gsd_digital_units: 'Digital Units',
  dbi_metric_gsd_physical_units: 'Physical Units',
  dbi_metric_gsd_digital_revenue_euro: 'Digital Revenue(€)',
  dbi_metric_gsd_physical_revenue_euro: 'Physical Revenue(€)',
  dbi_metric_gsd_sales_date: `GSD Sales Data`,
  dbi_metric_metacritic: `MetaCritic Score`,
  dbi_metric_metacritic_global: `MetaCritic Score(Global)`,
  dbi_metric_physical_units: 'Physical Units',
  //
  // dbi_metric_digitalRevenue_trends: 'Mscience US Digital Revenue($)',
  dbi_metric_digitalRevenue_trends: 'Mscience Digital Revenue($)',
  dbi_metric_mscience_lifetime_digital_revenue_trends: 'MScience Lifetime Digital Revenue($)',
  dbi_metric_mscience_lifetime_digital_units_trends: 'MScience Lifetime Digital Units',
  dbi_metric_physical_revenue_trends: 'NPD US Physical Revenue($)',
  dbi_metric_gsd_digital_revenue_euro_trends: 'GSD Digital Revenue(€)',
  dbi_metric_gsd_physical_revenue_euro_trends: 'GSD Physical Revenue(€)',
  dbi_metric_jptb_cumulative_revenue_trends: 'Steam Cumulative Revenue($)',
  dbi_metric_gsd_digital_units_trends: 'Mscience Digital Units',
  dbi_metric_gsd_physical_units_trends: 'NPD US Physical Units',
  dbi_metric_gsd_digital_units_units_trends: 'GSD Digital Units',
  dbi_metric_gsd_physical_units_gsd: 'GSD Physical Units',
  dbi_metric_lifetime_weighted_price_trends: 'Lifetime weighted price($)',
  dbi_metric_playtime_steam: 'Steam Avg. Playtime(hours)',
  dbi_metric_ast_us: 'Mscience US Digital AST($)',
  dbi_metric_digitalARPPU_trends: 'Mscience US Digital ARPPU($)',
  dbi_metric_no_update: 'No-Update',
  dbi_metric_playertime: 'Playtime',
  dbi_metric_metric_set: 'Metric Set',
  dbi_metric_customized: 'Customized',
  dbi_metric_source_steam_pcu: 'Steam PCU',
  dbi_metric_source_steam_acu: 'Steam ACU',

  dbi_metric_combine_alinea_analytics_calibration_lifetime_units_revenue: 'Cumulative Revenue',
  dbi_metric_combine_alinea_analytics_calibration_lifetime_units: 'Cumulative Units',
  dbi_metric_combine_alinea_analytics_calibration_total_players: 'Total Players',
  dbi_metric_combine_alinea_analytics_calibration_lifetime_wishlist: 'Lifetime Wishlist',
  dbi_metric_combine_alinea_analytics_calibration_budget: 'Budget',
  dbi_metric_combine_alinea_analytics_calibration_budget_marketing: 'Budget marketing',
  dbi_metric_combine_alinea_analytics_calibration_budget_development: 'Budget development',
};
